import { render, staticRenderFns } from "./AccidentPartys.vue?vue&type=template&id=ed97e1de"
import script from "./AccidentPartys.vue?vue&type=script&lang=js"
export * from "./AccidentPartys.vue?vue&type=script&lang=js"
import style0 from "./AccidentPartys.vue?vue&type=style&index=0&id=ed97e1de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports